import React, { ReactNode } from "react"
import { Grid2, List } from "@mui/material"
import { HelpCircle as HelpCircleIcon } from "lucide-react"

import { NavItem } from "@/components/Sidebar/NavItem"
import useStyles from "@/components/Sidebar/Nav/styles"

type NavProps = {
	children: ReactNode
	isCollapsed?: boolean
	variant?: "inbox" | "console"
	onHelpClick?: () => void
	className?: string
}

export const Nav = ({ children, isCollapsed, variant, onHelpClick, className }: NavProps) => {
	const classes = useStyles()

	return (
		<>
			<Grid2 size={12} className={className} sx={classes.navWrapper}>
				<List disablePadding sx={classes.nav}>
					{children}
				</List>
			</Grid2>

			{onHelpClick && (
				<Grid2 size={12}>
					<NavItem
						icon={<HelpCircleIcon size={20} />}
						label="Preciso de ajuda"
						onClick={onHelpClick}
						isCollapsed={isCollapsed}
						tone="muted"
						variant={variant}
					/>
				</Grid2>
			)}
		</>
	)
}
